import React from "react";
import styled from "styled-components";
import Header from "./header/Header";
import {FlexCenterContainer} from "../styles/Layout";
import {PanelContainer} from "../styles/Panel";
import MainPanelWrapper from "./MainPanel";
import ConstructionPanel from "./ConstructionPanel";
import SideNav from "./navigation/SideNav";
import useJwt from "../../shared/hooks/JwtHook";
import useShowNotifications from "../../shared/hooks/ShowNotificationsHook";
import BackgroundSummer from "../images/background_summer.jpg";
import BackgroundAutumn from "../images/background_autumn.png";
import BackgroundWinter from "../images/background_winter.png";
import BackgroundSpring from "../images/background_spring.png";


const getBackground = () => {
    const md = (month, day) => ({month, day})

    const before = (md1, md2) => (md1.month < md2.month) 
    || ((md1.month === md2.month) && (md1.day <= md2.day)) 

    const between = (mdX, mdLow, mdHigh) => 
    !before(mdX, mdLow) && before(mdX, mdHigh)
    
    const MARCH_EQUINOX = md(2, 20)
    const JUNE_SOLSTICE = md(5, 21)
    const SEPTEMBER_EQUINOX = md(8, 23)
    const DECEMBER_SOLSTICE = md(11, 21)

    const date = new Date();
    const cur_md = md(date.getMonth(), date.getDate());
    if (between(cur_md, MARCH_EQUINOX,JUNE_SOLSTICE)) {
        return BackgroundAutumn;
    } else if (between(cur_md, JUNE_SOLSTICE,SEPTEMBER_EQUINOX)) {
        return BackgroundWinter;
    } else if (between(cur_md, SEPTEMBER_EQUINOX,DECEMBER_SOLSTICE)) {
        return BackgroundSpring;
    } else {
        return BackgroundSummer;
    }
};


const Page = styled.div`
    background-image: url(${getBackground()});
    background-size: cover;
    
    min-width: 1000px;
    height: 100vh;
`;


/**
 * Wrapper component that MUST be used by every page
 */
const PageWrapper = (props) => {
    const { jwt } = useJwt();

    // Load notifications if a jwt is found
    useShowNotifications(jwt);

    return (
        <Page>
            <Header />
            <FlexCenterContainer>
                <PanelContainer>
                    {props.leftPanel || <SideNav />}
                </PanelContainer>
                <MainPanelWrapper>
                    {props.children}
                </MainPanelWrapper>
                <PanelContainer>
                    {!props.rightPanels?.length ? (<ConstructionPanel />) : props.rightPanels.map((x, i) => <React.Fragment key={i}>{x}</React.Fragment>)}
                </PanelContainer>
            </FlexCenterContainer>
        </Page>
    );
};

export default PageWrapper;
